import { createHashHistory } from 'history'
const history = createHashHistory()

export default {
  listen: history.listen,
  go: path => history.push(path),
  back: history.back
}